module.exports = "/_next/static/images/OgSegmentIndustryRetail-b8fe1442377956ace3a5d7b900dba731.png";